import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import {
  JOB_RUN_SEARCH_URL,
  useJobRunSearch,
} from 'src/apis/transparency-reporting/use-job-run-search';
import { useReportsPageParams } from 'src/pages/reporting/transparency-reporting/reports/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const ReportsOverview: FC = () => {
  const pageParams = useReportsPageParams();
  const params = useMemo(
    () =>
      pageParams.value.runDateType === 'RUN'
        ? { ...pageParams.value, valuesFrom: null, valuesTo: null }
        : { ...pageParams.value, runFrom: null, runTo: null },
    [pageParams.value]
  );
  const search = useJobRunSearch({
    jobRunSearchUrl: JOB_RUN_SEARCH_URL,
    params,
  });

  return <Page pageParams={pageParams} search={search} />;
};
